import React, { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { fetchInternalDoctor } from "services/doctor";

const InternalDoctorCheckbox = ({
  employee_id,
  setFilterValue,
  doctorId,
  isRequired,
  status,
}) => {
  const [selectedDoctorId, setSelectedDoctorId] = useState("");

  const { data, isLoading, error } = useQuery(
    ["internal-doctor-dropdown", employee_id],
    () => fetchInternalDoctor({ employee_id }),
    {
      keepPreviousData: false,
      staleTime: DROPDOWN_STALE_TIME,
    }
  );

  useEffect(() => {
    if (doctorId) {
      setSelectedDoctorId(doctorId);
    }
  }, [doctorId]);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error Loading Internal Type</div>;

  const doctorsData = data?.data?.data;
  let doctorsArray = [];

  if (doctorsData) {
    if (Array.isArray(doctorsData)) {
      doctorsArray = doctorsData;
    } else {
      doctorsArray = Object.values(doctorsData);
    }
  }

  const options = doctorsArray.map((item) => ({
    value: item?.id || item?.doctor_obj?.id,
    label: item?.doctor_name || item?.doctor_obj?.doctor_name,
  }));

  const isInvalid =
    isRequired && (selectedDoctorId == null || selectedDoctorId === "");

  const handleCheckboxChange = (value) => {
    // Only one doctor can be selected at a time (acts like a radio group,
    // but rendered as checkboxes to match the reference design).
    const newValue = selectedDoctorId === value ? "" : value;
    setSelectedDoctorId(newValue);
    setFilterValue(newValue);
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "20px",
          padding: "8px 0",
        }}
      >
        {options.map((option) => (
          <label
            key={option.value}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
            <input
              type="checkbox"
              checked={selectedDoctorId === option.value}
              onChange={() => handleCheckboxChange(option.value)}
              style={{
                width: "16px",
                height: "16px",
                accentColor: isInvalid ? "#dc3545" : undefined,
                cursor: "pointer",
              }}
            />
            {option.label}
          </label>
        ))}
      </div>
      {isInvalid && (
        <div style={{ color: "#dc3545", fontSize: "12px", marginTop: "5px" }}>
          This field is required
        </div>
      )}
    </>
  );
};

export default InternalDoctorCheckbox;